<template>
    <div class="el-table el-table--fit el-table--scrollable-x el-table--scrollable-y el-table--enable-row-transition mb-5" style="width: 100%; height: 140px;" v-if="Object.keys(this.formAnserDetail).length !== 0 && Object.keys(this.formAnserDetail.reject_reason).length > 0">
        <table class="table rounded table-top">
            <thead class="thead-dark text-center admin-comment">
            <tr>
                <th class="w-25 text-center">差し戻し日時</th>
                <th class="w-75 text-center">差し戻しコメント</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(reject_reason, index_reject_reason) in formAnserDetail.reject_reason" :key="index_reject_reason">
                <th class="w-25 text-center">{{ reject_reason.created_at_xx }}</th>
                <th class="w-75 text-center text-break">{{ reject_reason.comment }}</th>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: "RejectComment",
    props: {
        formAnserDetail: {
            type: Object,
            default: {}
        }
    }
}
</script>

<style scoped>
/*.admin-comment{*/
/*    height: 140px;*/
/*    overflow:auto;*/
/*}*/
tr {
    width: 100%;
    display: inline-table;
    table-layout: fixed;
}

table{
    height:200px;
    display: block;
}
tbody{
    overflow-y: auto;
    height: 100px;
    width: 99.90%;
    position: absolute;
}
table th, table td {
    padding: 1rem;
    vertical-align: top;
    border-top: 1px solid #EBEDF3;
}
</style>
